function StatisticsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.32 12.7504H15C12.51 12.7504 11.25 11.3404 11.25 8.55045V5.68045C11.25 4.66045 11.37 3.20045 12.43 2.40045C13.32 1.74045 14.6 1.69045 16.49 2.24045C18.97 2.96045 21.04 5.03045 21.76 7.51045C22.31 9.39045 22.26 10.6804 21.6 11.5604C20.8 12.6304 19.34 12.7504 18.32 12.7504ZM14.28 3.36045C13.87 3.36045 13.55 3.44045 13.34 3.60045C12.95 3.89045 12.76 4.57045 12.76 5.68045V8.56045C12.76 10.8004 13.62 11.2604 15.01 11.2604H18.33C19.43 11.2604 20.11 11.0704 20.41 10.6804C20.76 10.2204 20.73 9.30045 20.34 7.95045C19.76 5.98045 18.06 4.27045 16.09 3.70045C15.35 3.47045 14.75 3.36045 14.28 3.36045Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M11.0699 22.7484C10.5399 22.7484 9.99988 22.7084 9.45988 22.6184C5.36988 21.9584 2.03988 18.6384 1.37988 14.5484C0.529883 9.28837 3.91988 4.32837 9.10988 3.26837C9.51988 3.18837 9.90988 3.44837 9.99988 3.84837C10.0799 4.25837 9.81988 4.64837 9.41988 4.73837C5.02988 5.63837 2.14988 9.83837 2.87988 14.3084C3.43988 17.7684 6.24988 20.5784 9.70988 21.1384C14.1999 21.8584 18.3899 18.9684 19.2799 14.5584C19.3599 14.1484 19.7599 13.8884 20.1599 13.9684C20.5699 14.0484 20.8299 14.4484 20.7499 14.8484C19.7999 19.5184 15.7199 22.7484 11.0699 22.7484Z"
        className="fill"
        fill="#1C274C"
      />
    </svg>
  );
}

export default StatisticsIcon;
